import { initDeliveryDates } from "../components/delivery";
import { printLivraisonSection } from "../components/livraison";

initDeliveryDates();

printLivraisonSection();